import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const seoContent: { [key: string]: { title: string; description: string; keywords: string } } = {
    '/': {
        title: "Dr. Bushra Zahoor - Psychiatrist in Delhi NCR | Asiaz Hospital",
        description: "Dr. Bushra Zahoor, MBBS (Gold Medalist), MD, DNB (Psychiatry), provides clinical psychiatric care for anxiety, depression, bipolar disorder, and mental health conditions at Asiaz Hospital.",
        keywords: "psychiatrist Delhi NCR, depression care, anxiety management, bipolar disorder, addiction therapy, Dr. Bushra Zahoor, Asiaz Hospital"
    },
    '/best-psychiatrist-in-nizzamundin': {
        title: "Dr. Bushra Zahoor - Psychiatrist in Nizamuddin, Delhi | Asiaz Hospital",
        description: "Clinical psychiatric care in Nizamuddin by Dr. Bushra Zahoor. Evaluation and treatment for depression, anxiety, bipolar disorder, and mental health conditions. Call +91-9310330922.",
        keywords: "Dr. Bushra Zahoor, psychiatrist in Nizamuddin, depression care, anxiety management, bipolar disorder, relationship counseling, Delhi NCR"
    },
    '/expert-psychiatrist-south-delhi': {
        title: "Dr. Bushra Zahoor - Psychiatrist in South Delhi | Asiaz Hospital",
        description: "Comprehensive psychiatric care in South Delhi by Dr. Bushra Zahoor. Clinical care for depression, anxiety, bipolar disorder, and psychotherapy at Asiaz Hospital. Call +91-9310330922.",
        keywords: "Dr. Bushra Zahoor, psychiatrist in South Delhi, Asiaz Hospital, depression treatment, anxiety disorders, bipolar disorder, psychotherapy, relationship counseling, Nizamuddin"
    },
    '/best-mental-health-doctor-delhi-ncr': {
        title: "Dr. Bushra Zahoor - Psychiatrist & Mental Health Doctor in Delhi NCR | Asiaz Hospital",
        description: "Comprehensive mental health care across Delhi NCR by Dr. Bushra Zahoor. Clinical evaluation and treatment for depression, anxiety, bipolar disorder, and related conditions. Contact +91-9310330922.",
        keywords: "Dr. Bushra Zahoor, mental health doctor Delhi NCR, psychiatrist, depression treatment, anxiety management, bipolar disorder, psychosis, child psychiatry"
    },
    '/leading-psychiatrist-lajpat-nagar': {
        title: "Dr. Bushra Zahoor - Psychiatrist in Lajpat Nagar, Delhi | Asiaz Hospital",
        description: "Psychiatric consultations in Lajpat Nagar by Dr. Bushra Zahoor. Clinical evaluation and treatment for depression, anxiety, and complex mental health conditions. Contact +91-9310330922.",
        keywords: "Dr. Bushra Zahoor, psychiatrist in Lajpat Nagar, depression treatment, anxiety management, relationship counseling, addiction therapy, Delhi NCR"
    },
    '/best-psychiatrist-in-khan-market': {
        title: "Dr. Bushra Zahoor - Psychiatrist in Khan Market, Delhi | Asiaz Hospital",
        description: "Psychiatric care serving Khan Market by Dr. Bushra Zahoor. Clinical consultations for depression, anxiety, and stress-related conditions. Call +91-9310330922.",
        keywords: "Dr. Bushra Zahoor, psychiatrist in Khan Market, depression treatment, anxiety management, work-life balance, stress management, Delhi NCR"
    },
    '/top-psychologist-in-green-park': {
        title: "Dr. Bushra Zahoor - Psychiatrist in Green Park, Delhi | Asiaz Hospital",
        description: "Psychiatric consultations for Green Park residents by Dr. Bushra Zahoor. Clinical care for depression, anxiety, bipolar disorder, and psychotherapy. Contact +91-9310330922.",
        keywords: "Dr. Bushra Zahoor, psychiatrist in Green Park, mental health doctor Delhi, depression treatment, anxiety disorders, bipolar disorder, psychotherapy, stress management, relationship counseling"
    },
};

const SEOHelmet: React.FC = () => {
    const location = useLocation();
    const { title, description, keywords } = seoContent[location.pathname] || seoContent['/'];

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <meta name="robots" content="index, follow" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://southdelhipsychiatrist.com" />
            <meta property="og:location" content="Delhi NCR, Khan Market, Nizzamudin East, South Delhi, Lajpat Nagar, " />
        </Helmet>
    );
};

export default SEOHelmet;